@if (edge) {
  <oe-navigation-view>
    <ion-buttons header class="ion-justify-content-center">
      <div #ref><ng-content select="[custom-pickdate]"></ng-content></div>
      @if (!ref.children.length) {
        <pickdate></pickdate>
      }
    </ion-buttons>
    <oe-controller-heat-chart [isOnlyChart]="true">
    </oe-controller-heat-chart>
  </oe-navigation-view>
}
